import { render } from "./WelcomeContainer.vue?vue&type=template&id=0bfae690"
import script from "./WelcomeContainer.vue?vue&type=script&lang=js"
export * from "./WelcomeContainer.vue?vue&type=script&lang=js"

import "./WelcomeContainer.vue?vue&type=style&index=0&id=0bfae690&lang=css"

import exportComponent from "/vercel/path0/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__